import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import AppLogout from "../components/timeOutAlert";

const ProtectedRoute = ({ children }) => {
  const user = useSelector((state) => state.auth.user);

  return user ? <AppLogout>{children}</AppLogout> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
